// Todo el correo de un caso (su hilo y los unidos) y sus mensajes guardados, para verlos en una sola conversacion
// (lib/conversacionCaso). Cada hilo usa la misma consulta que la vista de correo (se comparte la cache).
import { useQueries, useQuery } from '@tanstack/react-query';

import { mensajesDeCaso } from '../../api/casos';
import { type CorreoOculto, type Mensaje, mensajesDeHilo, ocultosDeCaso } from '../../api/correo';

// `ocultosDe`: el caso del que se piden los correos que esta persona no puede leer (solo quien y cuando, capa 4).
export function useCorreoDelCaso(hilos: string[], casoId?: string | null, ocultosDe?: string | null) {
  const rs = useQueries({ queries: hilos.map((id) => ({ queryKey: ['correos', 'hilo', id], queryFn: () => mensajesDeHilo(id), refetchInterval: 60_000 })) });
  const guardados = useQuery({ queryKey: ['mensajes-caso', casoId], queryFn: () => mensajesDeCaso(casoId!), enabled: !!casoId, staleTime: 30_000, refetchInterval: 60_000 });
  const ocultos = useQuery({ queryKey: ['ocultos-caso', ocultosDe], queryFn: () => ocultosDeCaso(ocultosDe!), enabled: !!ocultosDe, staleTime: 60_000, refetchInterval: 2 * 60_000, retry: 1 });
  const correo: Mensaje[] = rs.flatMap((r) => r.data ?? []);
  return {
    correo,
    ocultos: (ocultos.data ?? []) as CorreoOculto[],
    // Por hilo, para marcar cada uno como leido.
    porHilo: hilos.map((id, i) => ({ id, ultimo: rs[i]?.data?.at(-1)?.receivedAt ?? null })),
    guardados: guardados.data ?? [],
    cargando: rs.some((r) => r.isLoading) || (!!casoId && guardados.isLoading),
    error: rs.find((r) => r.error)?.error ?? guardados.error ?? null,
    reintentar: () => (rs.forEach((r) => void r.refetch()), void guardados.refetch()),
  };
}
